module.exports = __webpack_public_path__ + "img/3.a0b9f507.png";